import { execGet } from 'services/RequestUtils';
import { IMandatorDetails } from 'types';

export function getMandatorDetails(
  mandatorId: string
): Promise<IMandatorDetails> {
  return execGet(
    `${process.env.REACT_APP_CORE_DATA_API}/public/mandators/${mandatorId}`,
    { cache: false }
  );
}
